<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="true"
    :nudge-right="40"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    :width="width"
    :max-width="width"
    :disabled="disabled"
  >
    <v-text-field
      solo
      slot="activator"
      :label="label"
      :value="formattedDate"
      :disabled="disabled"
      :loading="loading"
      :error-messages="errorMessages"
      :error-count="errorCount"
      :error="error"
      :hide-details="hideDetails"
      :append-icon="appendIcon"
      :prepend-icon="prependIcon"
      readonly>
    </v-text-field>

    <v-date-picker
      full-width
      :key="datePickerKey"
      :width="width"
      v-model="dateComputed"
      scrollable
      :locale="locale"
      :min="min"
      :max="max"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'PosDatePicker',
  model: {
    prop: 'date',
    event: 'input',
  },
  props: {
    date: {
      type: [Date, String],
      default: null,
    },
    min: {
      type: [Date, String],
      default: null,
    },
    max: {
      type: [Date, String],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 290,
    },
    format: {
      type: String,
      default: 'DD/MM/YYYY',
    },
    locale: {
      type: String,
      default: 'en-us',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: [String, Array],
      default: () => [],
    },
    errorCount: {
      type: [Number, String],
      default: 1,
    },
    error: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    appendIcon: {
      type: String,
    },
    prependIcon: {
      type: String,
    },
  },
  data() {
    return {
      datePickerKey: 0,
      selectedDate: null,
      menu: false,
    };
  },
  created() {
    if (this.date instanceof Date) {
      this.selectedDate = this.date;
    } else if (typeof this.date === 'string' || this.date instanceof String) {
      this.selectedDate = this.$moment(this.date, this.format);
    }
  },
  computed: {
    dateComputed: {
      get() {
        let val = this.selectedDate ? this.$moment(this.selectedDate).format(this.DATE_FORMAT) : '';
        return val;
      },
      set(val) {
        let date = this.$moment(val, this.DATE_FORMAT);
        let input = this.$moment().year(date.year()).month(date.month()).date(date.date()).hour(0);
        this.selectedDate = input.toDate();
        this.$emit('input', this.selectedDate);
      },
    },
    formattedDate() {
      return this.date ? this.$moment(this.date).format(this.format) : '';
    },
  },
  watch:{
    date(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.selectedDate = newVal;
        this.datePickerKey += 1;
      }
    },
  },
};
</script>
